// Date formatters
export const formatDate = (date, options = {}) => {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('uz-UZ', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...options,
  });
};

export const formatDateTime = (date) => {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleString('uz-UZ', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatRelativeTime = (date) => {
  if (!date) return '-';
  const d = new Date(date);
  const now = new Date();
  const diff = now - d;
  
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  
  if (minutes < 1) return 'Hozirgina';
  if (minutes < 60) return `${minutes} daqiqa oldin`;
  if (hours < 24) return `${hours} soat oldin`;
  if (days < 7) return `${days} kun oldin`;
  
  return formatDate(date);
};

export const formatTimeAgo = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const now = new Date();
  const diff = d - now;
  
  const days = Math.floor(diff / 86400000);
  
  if (days < 0) return `${Math.abs(days)} kun o'tgan`;
  if (days === 0) return 'Bugun';
  if (days === 1) return 'Ertaga';
  return `${days} kun qoldi`;
};

// Number formatters
export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  return new Intl.NumberFormat('uz-UZ').format(num);
};

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '0 so\'m';
  return new Intl.NumberFormat('uz-UZ', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount) + ' so\'m';
};

export const formatPercent = (value, total) => {
  if (!total || total === 0) return '0%';
  return ((value / total) * 100).toFixed(1) + '%';
};

// File formatters
export const formatFileSize = (bytes) => {
  if (!bytes) return '0 B';
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
};

export const getFileExtension = (filename) => {
  return filename?.split('.').pop()?.toLowerCase() || '';
};

export const getFileIcon = (filename) => {
  const ext = getFileExtension(filename);
  const icons = {
    pdf: '📄',
    doc: '📝',
    docx: '📝',
    xls: '📊',
    xlsx: '📊',
    ppt: '📽️',
    pptx: '📽️',
    jpg: '🖼️',
    jpeg: '🖼️',
    png: '🖼️',
    gif: '🖼️',
    zip: '📦',
    rar: '📦',
  };
  return icons[ext] || '📎';
};

// Status formatters
export const getStatusColor = (status) => {
  const colors = {
    new: 'info',
    viewed: 'info',
    in_progress: 'warning',
    pending: 'warning',
    submitted: 'warning',
    completed: 'success',
    completed_late: 'success',
    approved: 'success',
    rejected: 'danger',
    not_completed: 'danger',
    archived: 'gray',
    draft: 'gray',
    active: 'success',
    inactive: 'gray',
  };
  return colors[status] || 'gray';
};

export const getPriorityColor = (priority) => {
  const colors = {
    low: 'gray',
    medium: 'info',
    high: 'warning',
    urgent: 'danger',
  };
  return colors[priority] || 'gray';
};

// Text formatters
export const truncate = (str, length = 50) => {
  if (!str) return '';
  if (str.length <= length) return str;
  return str.substring(0, length) + '...';
};

export const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getInitials = (name) => {
  if (!name) return '?';
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);
};

// Query string helpers
export const buildQueryString = (params) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      searchParams.append(key, value);
    }
  });
  return searchParams.toString();
};

export const parseQueryString = (queryString) => {
  const params = new URLSearchParams(queryString);
  const result = {};
  params.forEach((value, key) => {
    result[key] = value;
  });
  return result;
};
